module.exports = __webpack_public_path__ + "img/innovation-red-500x500.fd5057d9.png";